import * as React from 'react';
import {IProduct} from "../../functions/Interfaces";
import './ProductPOP.css';

class ProductPOP extends React.Component<any, { product: IProduct }> {
  public render() {
    const product = this.props.product;

    return (
      <div className="pop">
        <div className="product-img-wrapper">
          <a href={ process.env.PUBLIC_URL + "/p/" + product.id} onClick={e => this.props.actionUp()}>
            <img alt={product.name} className="img-pop" src={product.picture} /> 
          </a>
        </div>
        <h4 title={product.name}>{product.name}</h4>
        <h5>{product.price + "€"}</h5>
      </div>
    );
  }
}
export default ProductPOP;


// WEBPACK FOOTER //
// ./src/components/product/ProductPOP.tsx